import { FiltroDeTitulos, Titulo } from "@/models/financeiro/Titulo";

export function limparFiltroDosCamposDeTitulos(): FiltroDeTitulos {
	return {
		pessoa: '',
		tipoDeCliente: '',
		dataInicioPeriodo: '',
		dataFimPeriodo: '',
		formaDePagamento: '',
		numeroDocumento: '',
		dataInicioPagamento: '',
		dataFimPagamento: '',
	}
}

export function calcularDataAposCarencia(titulo: Titulo, dataVencimento: Date): Date {
	const diasDeCarencia = titulo.diasDeCarencia || 0;

	const dataCarencia = new Date(dataVencimento);

	if (diasDeCarencia > 0) {
		dataCarencia.setDate(dataCarencia.getDate() + diasDeCarencia);
	} else {
		const diaSemanaVencimento = dataCarencia.getDay();
		if (diaSemanaVencimento === 6) {
			dataCarencia.setDate(dataCarencia.getDate() + 2);
		} else if (diaSemanaVencimento === 0) {
			dataCarencia.setDate(dataCarencia.getDate() + 1);
		}
	}
	diasDeCarencia > 0 ? dataCarencia.setDate(dataCarencia.getDate()) : dataCarencia;

	return new Date(
		dataCarencia.getFullYear(),
		dataCarencia.getMonth(),
		dataCarencia.getDate(),
	);
}

